// Textos da seção "Tendência e Estoque" das Configurações.
// Identificadores em inglês, texto visível em PT-BR.

export const TREND_METHOD_COPY = {
  budget: {
    label: "Orçamento",
    formula: "Tendência = Orçamento",
    when: "No começo da obra, quando ainda não há histórico suficiente para projetar nada.",
    example: "Orçamento de R$ 1.000.000 com 8% executado: a tendência é R$ 1.000.000.",
  },
  budget_plus_deviation: {
    label: "Orçamento + desvio incorrido",
    formula: "Tendência = Orçamento + (Custo acumulado − Medido)",
    when:
      "Postura intermediária: reconhece o desvio que já aconteceu, mas não assume que ele vai continuar até o fim.",
    example:
      "Orçamento de R$ 1.000.000, você gastou R$ 400.000 para entregar R$ 300.000: a tendência é R$ 1.100.000 — o orçamento mais os R$ 100.000 de desvio já incorrido.",
  },
  performance_extrapolation: {
    label: "Extrapolação do desempenho",
    formula: "Tendência = Custo acumulado ÷ avanço  (equivale a Orçamento ÷ IDC)",
    when:
      "Quando já existe histórico confiável: assume que o ritmo de custo observado até agora vai se manter até o fim.",
    example:
      "Você gastou R$ 1.000.000 para entregar 50% da obra: a tendência é R$ 2.000.000.",
  },
  committed: {
    label: "Comprometido",
    formula: "Tendência = Comprometido",
    when:
      "Quando a obra é gerida por contratação: o que vale é o que já está contratado, não o ritmo de gasto.",
    example:
      "R$ 600.000 contratados de um orçamento de R$ 1.000.000: a tendência é R$ 600.000 — ou R$ 1.000.000 se você somar os disponíveis positivos.",
  },
};

export const TREND_ADJUSTMENT_COPY = {
  positive_availables: {
    label: "Somar disponíveis positivos",
    help:
      "Acrescenta, item por item, a diferença entre orçamento e comprometido quando ela é positiva — ou seja, considera que a verba ainda não contratada será gasta.",
  },
  unposted_values: {
    label: "Somar estouros / economias",
    help:
      "Acrescenta os valores que você registrou na plataforma mas que ainda não existem no ERP.",
  },
  floor_committed: {
    label: "Nunca abaixo do comprometido",
    help:
      "Garante que a tendência nunca fique menor do que o que já está contratado. Recomendado deixar ligado.",
  },
};

export const STOCK_SOURCE_COPY = {
  none: {
    label: "Não considerar estoque",
    help: "O custo acumulado entra cheio no cálculo, inclusive o material comprado e ainda não aplicado.",
  },
  manual: {
    label: "Estoque lançado na plataforma",
    help: "Usa os valores que a sua equipe lança no detalhe de cada item.",
  },
  api: {
    label: "Estoque do almoxarifado (Sienge)",
    help: "Usa o inventário do depósito configurado na obra, sincronizado do Sienge.",
  },
  api_with_manual: {
    label: "Almoxarifado do Sienge, complementado pelo lançamento manual",
    help:
      "Nos itens que o almoxarifado do Sienge cobre, vale o Sienge. Nos itens que ele não cobre, vale o lançamento manual. As duas fontes nunca são somadas no mesmo item, para não contar o mesmo material duas vezes.",
  },
};

export const STOCK_IN_ORDER_PRESET = {
  bands: [{ from: 0, to: 100, method: "performance_extrapolation" }],
  adjustments: { positive_availables: false, unposted_values: false, floor_committed: true },
  // Lançamento manual, e NÃO `api_with_manual`, de propósito. Duas medições em produção
  // (28/07/2026) decidem isso:
  //   - `api_with_manual` dá precedência à API em todo nó que ela cubra com total
  //     positivo, e DESCARTA o lançamento manual daquele nó. Existe sobreposição real
  //     hoje: um nó tem R$ 303.000,00 de manual e R$ 132.912,94 de API — o preset
  //     apagaria os R$ 303.000,00 em silêncio.
  //   - só UMA obra da plataforma inteira tem estoque via API (181 docs), e 9,4% do
  //     valor dela cai em código que não existe no orçamento.
  // Ou seja: para quase todo cliente `api_with_manual` seria idêntico a `manual`, e no
  // único caso em que difere ele erra. Subir para `api_with_manual` é uma escolha
  // deliberada — o resumo de estoque agora informa `shadowed_manual_value`, quanto
  // custaria fazê-la.
  stock_source: "manual",
  zero_budget: "committed",
};

export const STOCK_IN_ORDER_HELP =
  "Se o seu estoque está atualizado, o custo acumulado já é fiel ao que foi realmente consumido — " +
  "e a tendência pode ser projetada desde o começo da obra. As faixas de 20% e 50% existem justamente " +
  "para compensar um custo acumulado que ainda não é confiável.";

export const STOCK_STALE_DAYS = 90;

// Copy do campo de data de competência e do aviso de obsolescência no lançamento
// manual de estoque (offcanvas de detalhe do item).
export const STOCK_REFERENCE_DATE_HELP =
  "A partir de quando este estoque vale. Um estoque antigo continua sendo descontado do custo acumulado — mantenha a data atualizada.";

export const STOCK_REFERENCE_DATE_STALE_WARNING =
  `Este estoque foi lançado há mais de ${STOCK_STALE_DAYS} dias e continua sendo descontado do custo. Confira se ainda é válido.`;
